import React, { useState, useEffect } from "react";
import "./App.css";

const icons = ["🍎", "🚗", "🐶", "🌙", "⚽", "🎧", "🔥", "💎"];

function shuffle(array) {
  return [...array].sort(() => Math.random() - 0.5);
}

function App() {
  const [cards, setCards] = useState([]);
  const [flipped, setFlipped] = useState([]);
  const [matched, setMatched] = useState([]);
  const [moves, setMoves] = useState(0);

  useEffect(() => {
    const doubled = [...icons, ...icons];
    setCards(shuffle(doubled));
  }, []);

  const handleFlip = (index) => {
    if (flipped.includes(index) || matched.includes(cards[index])) return;

    if (flipped.length === 2) return;

    setFlipped([...flipped, index]);
  };

  useEffect(() => {
    if (flipped.length === 2) {
      setMoves(moves + 1);

      const [first, second] = flipped;

      if (cards[first] === cards[second]) {
        setMatched([...matched, cards[first]]);
        setFlipped([]);
      } else {
        setTimeout(() => setFlipped([]), 700);
      }
    }
  }, [flipped]);

  const restartGame = () => {
    const doubled = [...icons, ...icons];
    setCards(shuffle(doubled));
    setFlipped([]);
    setMatched([]);
    setMoves(0);
  };

  return (
    <div className="container">
      <h1>Memory Match Game</h1>
      <p className="moves">Moves: {moves}</p>

      <div className="grid">
        {cards.map((icon, index) => {
          const isFlipped =
            flipped.includes(index) || matched.includes(icon);

          return (
            <div
              key={index}
              className={`card ${isFlipped ? "flipped" : ""}`}
              onClick={() => handleFlip(index)}
            >
              <div className="inner">
                <div className="front">❓</div>
                <div className="back">{icon}</div>
              </div>
            </div>
          );
        })}
      </div>

      <button className="restart" onClick={restartGame}>
        Restart Game
      </button>

      {matched.length === icons.length && (
        <h2 className="win">🎉 You Win! Great Memory!</h2>
      )}
    </div>
  );
}

export default App;
